export const ServiceType = Object.freeze({
  DELIVERY: 'DELIVERY',
  PICKUP: 'PICKUP',
});